import React, { Component } from "react";

class GenericSwitch extends Component {
  handleToggle = () => {
    const { checked, onChange, disabled } = this.props;

    if (disabled) return;

    if (onChange) {
      onChange(!checked);
    }
  };

  render() {
    const { checked, label, disabled } = this.props;

    return (
      <div className={`switch-container ${disabled ? "disabled" : ""}`}>
        <div
          className={`switch ${checked ? "on" : "off"}`}
          onClick={this.handleToggle}
        >
          <div className="switch-slider" />
        </div>
        {label && <span className="switch-label">{label}</span>}
      </div>
    );
  }
}

GenericSwitch.defaultProps = {
  checked: false,
  disabled: false,
  label: "",
  onChange: null
};

export default GenericSwitch;
